import { render, staticRenderFns } from "./AddLabel.vue?vue&type=template&id=6af9c293&scoped=true&"
import script from "./AddLabel.vue?vue&type=script&lang=js&"
export * from "./AddLabel.vue?vue&type=script&lang=js&"
import style0 from "./AddLabel.vue?vue&type=style&index=0&id=6af9c293&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af9c293",
  null
  
)

export default component.exports